export default __webpack_public_path__ + "static/media/Leg Upper Right.87a04446.jpg";